import React, { useEffect, useState } from "react";
import "./alert.css";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Drawer,
  Grid,
  Checkbox,
  Button,
  InputLabel,
  FormControl,
  TextField,
  InputAdornment,
  Typography,
  Alert,
  Table,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  Skeleton,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CancelIcon from "@mui/icons-material/Cancel";
import CustomTheme from "../../Customtheme/Themes";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import StyledTableCell from "../../Tabletheme/Customtableheader";
const AlertEdit = ({
  isOpen,
  setIsopen,
  handleClose,
  alertEdit,
  getAlterTypes,
  GetHandlingData,
}) => {
  const { drawerWidth, isXs, isSm, isMd, isLg, isXl } = CustomTheme();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [backDrop, setBackDrop] = useState(false);
  const [loader, setLoader] = useState(true);
  const [statusData, setStatusData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [totalRecods, setTotalRecods] = useState(0);
  const [information, setInformation] = useState({});
  const [handlingdata, setHandlingdata] = useState([]);
  const [allhandlingdata, setAllhandlingdata] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleRowSelect = (row) => {
    const selectedIndex = selectedRows.indexOf(row);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedRows, row);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelected = newSelected.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      );
    }

    setSelectedRows(newSelected);
  };
  const handleinputChange = (event) => {
    const { id, value } = event.target;
    let sanitizedValue;
    if (id === "alert_retry_num") {
      sanitizedValue = value.replace(/[^0-9]/g, "").slice(0, 2);
    } else if (id === "alert_retry_interval") {
      sanitizedValue = value.replace(/[^0-9]/g, "").slice(0, 5);
    } else {
      sanitizedValue = value;
    }
    setInformation((prevData) => ({
      ...prevData,
      [id]: sanitizedValue,
    }));
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (name === "messageTypeCheckbox") {
      setInformation((prevData) => ({
        ...prevData,
        show_for_message_type: checked ? 1 : 0,
      }));
    } else if (name === "alwaysLoggedCheckbox") {
      setInformation((prevData) => ({
        ...prevData,
        is_always_logged: checked ? 1 : 0,
      }));
    }
  };
  console.log("alwaysLoggedCheckbox", information.is_always_logged);
  const getStatusCode = () => {
    const body = {
      id: "",
      searchtext: "",
    };
    instance
      .post("api/v1/Master/MessageStatus/Get", body)
      .then((res) => {
        if (res?.data?.Success) {
          setTotalRecods(res?.data?.Records ?? 0);
          setStatusData(() => {
            return [...(res?.data?.Value ?? {})];
          });
        } else {
          setTotalRecods(0);
          setStatusData((prevData) => {
            return [...prevData];
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };

  const getCategory = () => {
    const body = {
      id: "",
      searchtext: "",
    };
    instance
      .post("api/v1/Master/AlertCategory/Get", body)
      .then((res) => {
        if (res?.data?.Success) {
          setTotalRecods(res?.data?.Records ?? 0);
          setCategoryData(() => {
            return [...(res?.data?.Value ?? {})];
          });
        } else {
          setTotalRecods(0);
          setCategoryData((prevData) => {
            return [...prevData];
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };

  const EditAlertType = (event) => {
    event.stopPropagation();
    setIsopen(true);
    const handlename = information?.alert_type_name?.trim();
    if (!handlename) {
      setError("Please enter Mandatory Fields.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
    } else {
      setBackDrop(true);
      const selectedIds = selectedRows.map(
        (row) => row.alert_handling_track_id
      );
      const prevSelected = handlingdata.map(
        (row) => row.alert_handling_track_id
      );
      const body = {
        alert_type_id: information?.alert_type_id,
        alert_type_name: information?.alert_type_name,
        alert_type_desc: information?.alert_type_desc,
        alert_category_id: information?.alert_category_id,
        alert_retry_num: information?.alert_retry_num,
        alert_retry_interval: information?.alert_retry_interval,
        is_always_logged: information?.is_always_logged,
        associated_message_status_id: information?.associated_message_status_id,
        show_for_message_type: information?.show_for_message_type,
        alert_handling_track_id: [...selectedIds, ...prevSelected].join(","),
      };
      instance
        .post("api/v1/Master/AlertType/Post", body)
        .then((res) => {
          console.log("resp", res);
          if (res?.data?.Success) {
            setError("");
            setSuccess(res?.data?.ResultMessage);
            getAlterTypes(1);
            tableData();
            alltableData();
            setTimeout(() => {
              setSuccess(null);
            }, 5000);
          } else {
            setError(res?.data?.ResultMessage);
            setTimeout(() => {
              setError(null);
            }, 5000);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setBackDrop(false);
        });
    }
  };
  const handleCloseErrorcode = () => {
    setError("");
  };
  const tableData = async () => {
    let data = await GetHandlingData(true, alertEdit.alert_type_id);
    setHandlingdata(data?.data?.Value ?? []);
  };
  const alltableData = async () => {
    let data = await GetHandlingData(false, alertEdit.alert_type_id);
    setAllhandlingdata(data?.data?.Value ?? []);
  };

  useEffect(() => {
    if (isOpen) {
      tableData();
      alltableData();
    }
  }, [isOpen]);

  useEffect(() => {
    getStatusCode();

    getCategory();
  }, []);
  useEffect(() => {
    setInformation(alertEdit);
  }, [alertEdit]);
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      PaperProps={{
        sx: {
          width: drawerWidth,
        },
      }}
    >
      <div style={{ padding: "20px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id="back-button"
              variant="contained"
              color="transparent"
              className="button_backAlert"
              onClick={handleClose}
              startIcon={<ArrowBackIcon onClick={handleClose} />}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              className="font-colorAlert mb-0"
              style={{ fontWeight: "600" }}
            >
              Edit Alert Type{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-colorAlert mb-1"
              style={{ fontWeight: "600" }}
            >
              Alert Type Information{" "}
            </Typography>
          </Grid>
          {error && (
            <Alert
              variant="outlined"
              severity="error"
              icon={<CancelIcon onClick={handleCloseErrorcode} />}
              className="errorAlert mt-4"
            >
              {error}
            </Alert>
          )}
          {success && (
            <Alert
              variant="outlined"
              severity="success"
              className="sucessAlert mt-4"
            >
              {success}
            </Alert>
          )}
          <Grid item xs={12}>
            <InputLabel htmlFor="alert_type_name">Alert Name</InputLabel>
            <TextField
              id="alert_type_name"
              size="small"
              variant="outlined"
              value={information.alert_type_name}
              onChange={(event) => handleinputChange(event)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="alert_type_desc">Description</InputLabel>
            <TextField
              id="alert_type_desc"
              size="small"
              multiline
              rows={4}
              variant="outlined"
              value={information?.alert_type_desc}
              onChange={(event) => handleinputChange(event)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="autocomplete-search">Category</InputLabel>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="autocomplete-search"
                options={categoryData}
                getOptionLabel={(option) => option.alert_category_name}
                value={
                  categoryData.find(
                    (option) =>
                      option.alert_category_id === alertEdit.alert_category_id
                  ) || ""
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    setInformation((prevData) => ({
                      ...prevData,
                      alert_category_id: newValue.alert_category_id || 0,
                    }));
                  } else {
                    setInformation((prevData) => ({
                      ...prevData,
                      alert_category_id: 0,
                    }));
                  }
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    // InputProps={{
                    //   ...params.InputProps,
                    //   endAdornment: (
                    //     <InputAdornment
                    //       position="end"
                    //       style={{ position: "absolute", right: 20 }}
                    //     >
                    //       <img
                    //         src="assets/Images/searchicon.svg"
                    //         alt="Search Icon"
                    //       />
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="alert_retry_num">Number of Retries</InputLabel>
            <TextField
              id="alert_retry_num"
              size="small"
              onChange={(event) => handleinputChange(event)}
              variant="outlined"
              value={information.alert_retry_num}
              fullWidth
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="alert_retry_interval">
              Retries Interval
            </InputLabel>
            <TextField
              id="alert_retry_interval"
              size="small"
              value={information.alert_retry_interval}
              onChange={(event) => handleinputChange(event)}
              variant="outlined"
              fullWidth
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="autocomplete-search">
              Associated Message Status
            </InputLabel>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="autocomplete-search"
                options={statusData}
                getOptionLabel={(option) => option.message_status_name}
                value={
                  statusData.find(
                    (option) =>
                      option.message_status_id ===
                      alertEdit.associated_message_status_id
                  ) || ""
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    setInformation((prevData) => ({
                      ...prevData,
                      associated_message_status_id:
                        newValue.message_status_id || 0,
                    }));
                  } else {
                    setInformation((prevData) => ({
                      ...prevData,
                      associated_message_status_id: 0,
                    }));
                  }
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    // InputProps={{
                    //   ...params.InputProps,
                    //   endAdornment: (
                    //     <InputAdornment
                    //       position="end"
                    //       style={{ position: "absolute", right: 20 }}
                    //     >
                    //       <img
                    //         src="assets/Images/searchicon.svg"
                    //         alt="Search Icon"
                    //       />
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} className="mb-0">
            <Checkbox
              color="secondary"
              name="messageTypeCheckbox"
              checked={information?.show_for_message_type === 1}
              onChange={handleCheckboxChange}
            />
            <Typography variant="h7" className="font-colorAlert">
              Appears on Message Type?
            </Typography>
          </Grid>
          <Grid item xs={12} className="mb-1">
            <Checkbox
              color="secondary"
              name="alwaysLoggedCheckbox"
              checked={information?.is_always_logged === 1}
              onChange={handleCheckboxChange}
            />
            <Typography variant="h7" className="font-colorAlert">
              Is Always Logged
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <div style={{ display: "flex" }}>
              <Typography
                variant="h7"
                className="font-color mb-1"
                style={{ fontWeight: "600" }}
              >
                Selected Handling Tracks
              </Typography>
              {/* <p
              style={{ marginLeft: "auto", textDecoration: "underline" }}
            >
              Configure
              <ArrowForwardIcon />
            </p> */}
            </div>
          </Grid>
          <TableContainer sx={{ margin: 1, maxHeight: 200 }} component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow className="Table_rowAlert">
                  <StyledTableCell> Handling Track ID</StyledTableCell>
                </TableRow>
              </TableHead>
              {loader ? (
                <>
                  {new Array(2).fill(3).map((element, index) => {
                    return (
                      <TableRow key={index}>
                        {new Array(7).fill(1).map((element, index) => {
                          return (
                            <TableCell align="center" key={index}>
                              <Skeleton
                                variant="rounded"
                                width={"100%"}
                                height={60}
                              />
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </>
              ) : (
                <>
                  {handlingdata.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        <p>No Data Found</p>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <TableBody>
                      {handlingdata.map((row, index) => {
                        //  const isSelected = selectedRows.indexOf(row) !== -1;
                        return (
                          <TableRow
                            key={index}
                            // selected={isSelected}
                            // onClick={() => handleRowSelect(row)}
                            hover
                          >
                            <TableCell
                              style={{ minWidth: "10rem", maxWidth: "10rem" }}
                            >
                              {row.alert_handling_track_name}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}{" "}
                </>
              )}
            </Table>
          </TableContainer>
          <Grid item xs={12}>
            <div style={{ display: "flex" }}>
              <Typography
                variant="h7"
                className="font-color mb-1"
                style={{ fontWeight: "600" }}
              >
                Handling Tracks
              </Typography>
              <p style={{ marginLeft: "auto", textDecoration: "underline" }}>
                Configure
                <ArrowForwardIcon />
              </p>
            </div>
          </Grid>
          <TableContainer sx={{ margin: 1, maxHeight: 200 }} component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow className="Table_rowAlert">
                  <StyledTableCell> Handling Track ID</StyledTableCell>
                  <StyledTableCell />
                </TableRow>
              </TableHead>
              {loader ? (
                <>
                  {new Array(2).fill(3).map((element, index) => {
                    return (
                      <TableRow key={index}>
                        {new Array(7).fill(1).map((element, index) => {
                          return (
                            <TableCell align="center" key={index}>
                              <Skeleton
                                variant="rounded"
                                width={"100%"}
                                height={60}
                              />
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </>
              ) : (
                <>
                  {allhandlingdata.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        <p>No Data Found</p>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <TableBody>
                      {allhandlingdata.map((row, index) => {
                        const isSelected = selectedRows.indexOf(row) !== -1;
                        return (
                          <TableRow
                            key={index}
                            // selected={isSelected}
                            // onClick={() => handleRowSelect(row)}
                            hover
                          >
                            <TableCell
                              style={{ minWidth: "10rem", maxWidth: "10rem" }}
                            >
                              {row.alert_handling_track_name}
                            </TableCell>
                            <TableCell
                              style={{ minWidth: "2rem", maxWidth: "2rem" }}
                            >
                              <Checkbox
                                color="secondary"
                                checked={isSelected}
                                onChange={() => handleRowSelect(row)}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}{" "}
                </>
              )}
            </Table>
          </TableContainer>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              onClick={(event) => EditAlertType(event)}
            >
              Save Changes
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

export default AlertEdit;
